module.exports = __webpack_public_path__ + "img/game_main_pc_207_off.5c6e4ce9.png";